import { api, unwrap } from "./httpClient";
import type {
  PortfolioSummary,
  UpsertPortfolioPayload,
  AccountBalances,
} from "../types/api";

export const getPortfolioSummary = (userId: number) =>
  unwrap<PortfolioSummary>(
    api({ method: "GET", url: `/portfolio/${userId}/summary` })
  );

export const getAccountBalances = (userId: number) =>
  unwrap<AccountBalances>(
    api({ method: "GET", url: `/portfolio/${userId}/balances` })
  );

export const upsertPortfolioPosition = (payload: UpsertPortfolioPayload) =>
  unwrap<{ ok: boolean }>(
    api({ method: "PUT", url: "/portfolio/position", data: payload })
  );
